import type { Recipe } from "./types";

export function extractRecipes(response: { data?: Recipe[] } | Recipe[]): Recipe[] {
  return Array.isArray(response) ? response : response.data || [];
}

export function sanitizeFilterValue(value: string | number | null | undefined): boolean {
  return value !== null && value !== undefined && value !== "" && value !== "null" && value !== "undefined";
}

export function sanitizeDietTypes(dietTypes: string[]): string[] {
  return dietTypes.filter((diet) => diet && diet !== "null" && diet !== "undefined");
}

export function sanitizeAllergens(allergens: (string | number)[]): (string | number)[] {
  return allergens.filter(sanitizeFilterValue);
}
